var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"help-icon"},[_c('Icon',{attrs:{"id":_vm.helpId,"name":"question-circle","title":""}}),_c('BPopover',{attrs:{"target":_vm.helpId,"triggers":"hover focus"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.help)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }